export default "__VITE_ASSET__BpUb2Nc0__"